export const env_vars_fields = {
  Job: ["job_name", "comments", "date", "type"],
  Scheduler: [
    "scheduler_termiter",
    "scheduler_restrictcsrefs",
    "scheduler_ignorecsrefs",
    "scheduler_showlevel",
    "scheduler_showtimestamp",
    "scheduler_showdatestamp",
    "scheduler_showhostname",
    "scheduler_slaveshavedata",
    "scheduler_slaveshavemodel",
    "scheduler_slaveshaveupdate",
    "scheduler_forceslavesgetmodel",
    "scheduler_dumprwi2update",
    "scheduler_writeupdate",
    "scheduler_dumprawgrad",
    "scheduler_dumprawprec",
    "scheduler_dumpprec",
    "scheduler_dumpstructsmth",
    "scheduler_dumpstartden",
    "scheduler_checkpointdir",
  ],
  Slaves: [
    "slaves_cigsmoothwidth",
    "slaves_cigsmoothwidth",
    "slaves_showlevel",
    "slaves_showtimestamp",
    "slaves_showdatestamp",
    "slaves_showhostname",
    "slaves_dumpcsrefs",
    "slaves_dumpraw",
    "slaves_dumpgrad",
    "slaves_dumpcompare",
    "slaves_showdatacorr",
    "slaves_dumprcvr",
    "scheduler_dumpdensity",
    "slaves_dumpresids",
    "slaves_dumpadjoint",
    "slaves_dumpmatchfilt",
    "slaves_dumpmatchfilter",
    "slaves_dumpmatchingfilter",
    "slaves_dumplowpass",
    "slaves_showdatarms",
    "slaves_showdataavabs",
    "scheduler_dumpstarden",
    "slaves_dipolercvrs",
    "slaves_dipolesrcs",
    "slaves_highkernvsterm",
  ],
};